import React, { FunctionComponent } from 'react';

import { supportsDeviceChange } from '../../../../../../helpers/browser-capabilities';
import { VideoStub } from './video-stub';
import { VideoSupported } from './video-supported';

export const VideoSection: FunctionComponent = () => {
    if (!supportsDeviceChange()) {
        return <VideoStub />;
    }

    return <VideoSupported />;
};
